import { apiClient } from './client'

export interface AchievementItem {
  code: string
  title: string
  description: string
  icon: string
  unlocked: boolean
  unlockedAt: string | null
}

export interface AchievementUnlock {
  code: string
  title: string
  description: string
  icon: string
  unlockedAt: string
}

export interface AchievementsResponse {
  achievements: AchievementItem[]
}

export const achievementsApi = {
  getAll: () => apiClient.get<AchievementsResponse>('/achievements').then((r) => r.data),
}
